import React, { ReactNode } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import Modal from '../Modal/Modal';

interface FreePlanLimitModalProps {
  // Undefined hides the confirm ("View plans") button entirely — used by
  // AgentForm when the current user can't manage billing.
  onViewPlans?: () => void;
  onBackToAgents: () => void;
  children?: ReactNode;
}

// The "you've hit the free-plan agent limit" modal shared by AgentForm and
// ChatAgentForm.
const FreePlanLimitModal: React.FC<FreePlanLimitModalProps> = ({
  onViewPlans,
  onBackToAgents,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      modalShouldBeOpen={true}
      showButton={false}
      mainPromptText={t('Free plan agent limit')}
      description={t('Free plan agent limit description')}
      confirmText={onViewPlans ? t('View plans') : undefined}
      denyText={t('Back to agents')}
      confirmButtonColor="primary"
      callback={onViewPlans}
      denyCallback={onBackToAgents}
    >
      {children}
    </Modal>
  );
};

export default FreePlanLimitModal;
